"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _reactSpring = require("react-spring");

var _reactUseMeasure = _interopRequireDefault(require("react-use-measure"));

var _resizeObserver = require("@juggle/resize-observer");

var _easing = _interopRequireDefault(require("../../_helpers/easing"));

var _mobxReact = require("mobx-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

require("./Expandable.css");

var _styles = {
  "container": "Expandable__container___5Pi3p",
  "content": "Expandable__content___2D671",
  "has-table": "Expandable__has-table___1ACSM"
};

const styles = _bind.default.bind(_styles);

const Expandable = (0, _mobxReact.observer)(({
  dataTestId,
  className,
  children,
  expand,
  showAsExpanded = false,
  restOnExpansion = false,
  duration = 400
}) => {
  const composed_classname = (0, _bind.default)(styles('container'), className);
  const [ref, {
    height: viewHeight
  }] = (0, _reactUseMeasure.default)({
    polyfill: _resizeObserver.ResizeObserver
  });
  const [springStyles, animate] = (0, _reactSpring.useSpring)(() => ({
    opacity: 0,
    height: 0,
    overflow: 'hidden',
    config: {
      duration,
      easing: _easing.default.easeInOutCubic
    }
  }));
  const firstExpansion = (0, _react.useRef)(true);
  const expandRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    if (expand && viewHeight < 1 && !_reactSpring.Globals.skipAnimation) {
      return;
    } else if (expand === expandRef.current) {
      if (restOnExpansion) {
        animate.set({
          height: expand ? viewHeight : 0
        });
      } else {
        animate.start({
          height: expand ? viewHeight : 0
        });
      }

      return;
    } else if (firstExpansion.current) {
      firstExpansion.current = false;

      if (expand && showAsExpanded) {
        expandRef.current = expand;
        animate.set({
          opacity: 1,
          height: viewHeight,
          overflow: 'visible'
        });
        return;
      }
    }

    expandRef.current = expand;

    if (expand) {
      animate.start({
        opacity: 1,
        height: viewHeight,
        overflow: 'hidden'
      })[0].then(() => {
        if (expand) {
          animate.set({
            overflow: 'visible'
          });
        }
      });
    } else {
      animate.start({
        opacity: 0,
        height: 0,
        overflow: 'hidden'
      });
    }
  }, [expand, viewHeight, restOnExpansion]);
  return _react.default.createElement(_reactSpring.animated.div, {
    className: composed_classname,
    style: springStyles,
    "data-testid": dataTestId
  }, _react.default.createElement("div", {
    className: styles('content'),
    ref: ref
  }, children));
});
var _default = Expandable;
exports.default = _default;